module.exports = __webpack_public_path__ + "static/media/timber02.18e497cf.png";